import React from 'react';
import './Footer.css';
import { SlShareAlt } from "react-icons/sl";


const instagram = <svg className="social-icon" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.336 3.608 1.311.975.975 1.249 2.242 1.311 3.608.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.062 1.366-.336 2.633-1.311 3.608-.975.975-2.242 1.249-3.608 1.311-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.336-3.608-1.311-.975-.975-1.249-2.242-1.311-3.608-.058-1.266-.07-1.646-.07-4.85s.012-3.584.07-4.85c.062-1.366.336-2.633 1.311-3.608.975-.975 2.242-1.249 3.608-1.311 1.266-.058 1.646-.07 4.85-.07zM12 0C8.741 0 8.332.014 7.052.072 5.772.13 4.893.308 4.124.634c-.787.339-1.456.794-2.121 1.459-.665.665-1.12 1.334-1.459 2.121-.326.769-.504 1.648-.562 2.928C.014 8.332 0 8.741 0 12c0 3.259.014 3.668.072 4.948.058 1.28.236 2.159.562 2.928.339.787.794 1.456 1.459 2.121.665.665 1.334 1.12 2.121 1.459.769.326 1.648.504 2.928.562 1.28.058 1.689.072 4.948.072s3.668-.014 4.948-.072c1.28-.058 2.159-.236 2.928-.562.787-.339 1.456-.794 2.121-1.459.665-.665 1.12-1.334 1.459-2.121.326-.769.504-1.648.562-2.928.058-1.28.072-1.689.072-4.948s-.014-3.668-.072-4.948c-.058-1.28-.236-2.159-.562-2.928-.339-.787-.794-1.456-1.459-2.121-.665-.665-1.334-1.12-2.121-1.459-.769-.326-1.648-.504-2.928-.562C15.668.014 15.259 0 12 0z"/>
                                <path d="M12 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/></svg>


const Footer = () => {
  const currentYear = 2026;

  const footerSections = [
    {
      title: 'Explore',
      links: [
        { name: 'Home', url: '/', external: false },
        { name: 'About', url: '/about', external: false },
      ]
    },
    {
      title: 'Connect',
      links: [
        { 
          name: instagram,
          url: 'https://www.instagram.com/cinema_recs', 
          // external but we don't want to show the arrow
        },
        { 
          name: <><SlShareAlt />SHARE</>, 
          url: '#', 
          external: false, 
          onClick: () => shareSite(),
          isHighlighted: true 
        }
      ]
    },

  ];

  const shareSite = () => {
    if (navigator.share) {
      navigator.share({
        title: 'Cinema Recommendations',
        text: 'Check out this awesome movie recommendation site!',
        url: window.location.href,
      })
      .catch(console.error);
    } else {
      // Fallback: copy to clipboard
      navigator.clipboard.writeText(window.location.href);
      alert('Link copied to clipboard!');
    }
  };

  const renderLink = (link, index) => {
    if (link.onClick) {
      return (
        <button 
          key={index}
          className={`footer-link ${link.isHighlighted ? 'footer-link--highlighted' : ''}`}
          onClick={link.onClick}
        >
          {link.name}
          {link.isHighlighted && <span className="share-icon"></span>}
        </button>
      );
    }

    if (link.external) {
      return (
        <a 
          key={index}
          href={link.url}
          className="footer-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          {link.name}
          <span className="external-indicator">↗</span>
        </a>
      );
    }

    return (
      <a 
        key={index}
        href={link.url}
        className="footer-link"
      >
        {link.name}
      </a>
    );
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-brand">
            <h3 className="footer-logo">🎬 CineRecs</h3>
            <p className="footer-tagline">
              Discover your next favorite movie.
            </p>
            <div className="footer-social">
            </div>
          </div>

          {/* Links Sections */}
          <div className="footer-links-grid">
            {footerSections.map((section, index) => (
              <div key={index} className="footer-section">
                <h4 className="footer-section-title">{section.title}</h4>
                <div className="footer-links">
                  {section.links.map((link, linkIndex) => renderLink(link, linkIndex))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="footer-copyright">
              © {currentYear} CineRecs. All rights reserved.
            </div>
            <div className="footer-legal">
              <span>Made with ❤️ for movie lovers</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
